export default __webpack_public_path__ + "static/media/filter.44fffbee.svg";